module.exports = __webpack_public_path__ + "static/media/roberto-cavalli.02a0f17d.jpg";